import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { MobileMenu } from '@/components/home/mobile-menu';

export function HomeHeader() {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary to-purple-600 flex items-center justify-center shadow-sm">
              <span className="text-white font-bold text-sm">V</span>
            </div>
            <span className="font-bold text-xl">Vakpeg</span>
          </Link>

          {/* Desktop Navigation - Centered */}
          <nav className="hidden md:flex items-center gap-10 mx-auto">
            <Link
              href="/#products"
              className="text-base font-semibold hover:text-primary transition-colors"
            >
              Products
            </Link>
            <Link
              href="/#pricing"
              className="text-base font-semibold hover:text-primary transition-colors"
            >
              Pricing
            </Link>
            <Link
              href="/blog"
              className="text-base font-semibold hover:text-primary transition-colors"
            >
              Blog
            </Link>
            <Link
              href="/news"
              className="text-base font-semibold hover:text-primary transition-colors"
            >
              AI Newsletter
            </Link>
          </nav>

          {/* Login Button - Right */}
          <div className="hidden md:block ml-auto">
            <Link href="/login">
              <Button variant="default" size="sm">
                Login
              </Button>
            </Link>
          </div>

          {/* Mobile Menu */}
          <MobileMenu />
        </div>
      </div>
    </header>
  );
}
